import React from "react";
import { LOGO_URL } from "@/lib/api";

export default function LogoMark({ size = 40, showText = true, className = "" }) {
    return (
        <div className={`flex items-center gap-3 ${className}`} data-testid="logo-mark">
            <img
                src={LOGO_URL}
                alt="Bradshaw Solutions"
                style={{ height: size, width: size }}
                className="object-contain drop-shadow-[0_0_12px_rgba(212,175,55,0.25)]"
            />
            {showText && (
                <div className="leading-none">
                    <div className="font-display text-lg sm:text-xl font-bold tracking-wide text-white">
                        BRADSHAW
                    </div>
                    <div className="text-[10px] tracking-[0.35em] text-gold-500 font-semibold">
                        SOLUTIONS
                    </div>
                </div>
            )}
        </div>
    );
}
